// Copyright 2026 Bitech.id. Licensed under the MIT License.

import { BreadcrumbBuffer, DEFAULT_MAX_BREADCRUMBS } from '../breadcrumbs/breadcrumbs.js';
import type { Breadcrumb, UserInfo } from '../types.js';

export class Scope {
  private readonly breadcrumbs: BreadcrumbBuffer;
  private tags: Record<string, string> = {};
  private user: UserInfo | undefined;
  private contexts: Record<string, Record<string, unknown>> = {};

  constructor(maxBreadcrumbs: number = DEFAULT_MAX_BREADCRUMBS) {
    this.breadcrumbs = new BreadcrumbBuffer(maxBreadcrumbs);
  }

  setTag(key: string, value: string): void {
    this.tags[key] = value;
  }

  setTags(tags: Record<string, string>): void {
    Object.assign(this.tags, tags);
  }

  setUser(user: UserInfo | undefined): void {
    this.user = user;
  }

  setContext(key: string, context: Record<string, unknown>): void {
    this.contexts[key] = context;
  }

  addBreadcrumb(breadcrumb: Omit<Breadcrumb, 'timestamp'> & { timestamp?: string }): void {
    this.breadcrumbs.add(breadcrumb);
  }

  getTags(): Record<string, string> {
    return { ...this.tags };
  }

  getUser(): UserInfo | undefined {
    return this.user;
  }

  getContexts(): Record<string, Record<string, unknown>> {
    return { ...this.contexts };
  }

  getBreadcrumbs(): Breadcrumb[] {
    return this.breadcrumbs.getAll();
  }

  clear(): void {
    this.tags = {};
    this.user = undefined;
    this.contexts = {};
    this.breadcrumbs.clear();
  }
}
